import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { apiGetServices } from 'utils/apis/application.api';
import  Button  from 'components/Button';
// import ButtonLanguage from 'components/Button-Language';
import { Logo, Ssocard, Subcard, Texthead, Textsubhead, LoginScreen, AppVersion } from 'css/Styled-sso';
import { LayoutApp } from '../../layout/Layout';
import { Spin } from 'antd';
import packageInfo from '../../../package.json';

const { version } = packageInfo;

// Maps a service's `name` (from the services collection) to its button styling.
// Service display/color are used except for SCG branding when scgc_only is false.
const SERVICE_CONFIG = {
    LOCAL: { color: "yellow", img: "/local-icon.png", fallbackDisplay: "Email" },
    SCGC: { color: "green", img: "/scgc-icon.png", fallbackDisplay: "SCGC" },
    LSP: { color: "orange", img: "/lsp-icon.png", fallbackDisplay: "LSP" },
    FACEBOOK: { color: "blue", img: "facebook.png", fallbackDisplay: "Facebook" },
    GOOGLE: { color: "google-blue", img: "google.png", fallbackDisplay: "Google" }
};

export const SSO = (props) => {
    let navigate = useNavigate();
    const [appname, setAppname] = useState();
    const [service, setService] = useState();
    const [logo, setLogo] = useState(`./scgc-logo.png`);
    const [showAppname, setShowappname] = useState(true);
    const [serviceList, setServiceList] = useState([]);
    const [scgcOnly, setScgcOnly] = useState(false);
    const { appId } = useParams();
    const [title, setTitle] = useState("SSO2");
    const [loading, setLoading] = useState(true);
    const [bg, setBg ] = useState(``);
    const [typeBg, setTypeBg] = useState(``);

    const getServices = async()=>{
        await apiGetServices(appId).then(async(res)=>{
            setAppname(res.name);
            setScgcOnly(res.scgc_only === true);
            res.logo?.full_url && setLogo(res.logo.full_url);
            if(res?.background?.full_url){
                setBg(res.background.full_url);
                setTypeBg("background-image")
            }
            if(res.services?.length){
                // Sort by `order` ascending; services without an `order` value go last.
                const sorted = [...res.services].sort((a, b) => {
                    const orderA = a.order != null && a.order !== "" ? Number(a.order) : Infinity;
                    const orderB = b.order != null && b.order !== "" ? Number(b.order) : Infinity;
                    return orderA - orderB;
                });
                setServiceList(sorted);
            }
            setLoading(false)
        }).catch((err)=>{
            navigate("/");
        });
    }

    useEffect(()=>{
        getServices()
        sessionStorage.removeItem("former-token");
    },[]);

    useEffect(() => {
        // This will run when the page first loads and whenever the title changes
        document.title = title;
    }, [title]);


    const onButtonClick = (msg) => {
        // alert(`${msg} button clicked!`)
    }

    return (
        <LoginScreen>
        {loading ? 
        <div className='position-spin'>
            <Spin tip="Loading..." spinning={loading} />
        </div>
        :
        <LayoutApp bg={bg} typeBg={typeBg}>
            <Ssocard>
                <Logo src={logo} alt='Logo' className='logo'/>
                <Subcard>
                    {showAppname && <Texthead>{appname ? `Sign in to ${appname}` : 'Sign in'}</Texthead>}
                    {serviceList.map((s) => {
                        const config = SERVICE_CONFIG[s.name];
                        if(!config) return null;
                        const useScgBranding = s.name === "SCGC" && !scgcOnly;
                        const displayName = useScgBranding ? "SCG" : s.display || config.fallbackDisplay;
                        return (
                            <Button
                                key={s.name}
                                variant="flat"
                                secondary={s.name === "LOCAL"}
                                color={useScgBranding ? "#DE1A22" : s.color || config.color}
                                msg={`Sign in with ${displayName}`}
                                img={s.name === "SCGC" ? (scgcOnly ? "/scgc-icon.png" : "/scg-icon.png") : config.img}
                                url={s.url}
                                onClick={onButtonClick}
                            />
                        );
                    })}
                </Subcard>
            </Ssocard>
        </LayoutApp>
        }
        <AppVersion>v{version}</AppVersion>
        </LoginScreen>
    )
}